import { UseQueryResult } from '@tanstack/react-query';
import { z } from 'zod';

import { AuthResponse, User } from '@/types/auth/auth';

import { api, setToken } from './api-client';
import { useUser } from './auth';

export const mfaInputSchema = z.object({
  mfa_code: z
    .string()
    .regex(/^\d{6}$/, 'MFAコードは6桁の数字で入力してください'),
});

export type MfaInput = z.infer<typeof mfaInputSchema>;
const checkMfa = async (data: MfaInput): Promise<AuthResponse> => {
  console.info('mfa.tsx_1');

  const formData = new FormData();
  formData.append('mfa_code', data.mfa_code);

  return await api.post('/mfa/check', formData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

const enableMfa = async (
  user: UseQueryResult<User, unknown>,
): Promise<void> => {
  console.info('mfa.tsx_2');
  await api.put('/mfa/enable');
  user.refetch();
  return;
};

const disableMfa = async (
  user_id: number | undefined,
  user: UseQueryResult<User, unknown>,
): Promise<void> => {
  console.info('mfa.tsx_3');
  if (!user_id) {
    console.info('mfa.tsx_4');
    await api.put('/mfa/disable', {});
  } else {
    console.info('mfa.tsx_5');
    await api.put('/mfa/disable', { user_id: user_id });
  }
  user.refetch();
  return;
};

const issueMfa = async (): Promise<void> => {
  console.info('mfa.tsx_6');
  return await api.put('/mfa/issue');
};

export const useVerifyMfa = () => {
  console.info('mfa.tsx_7');
  return {
    verifyMfa: async (data: MfaInput) => {
      const response = await checkMfa(data);
      if (response.access_token) {
        console.info('mfa.tsx_8');
        setToken(response.access_token);
      }
      console.info('mfa.tsx_9');
      return;
    },
  };
};

export const useSettingMfa = () => {
  console.info('mfa.tsx_10');
  const user = useUser();
  return {
    enableMfa: async () => {
      console.info('mfa.tsx_11');
      await enableMfa(user);
    },
    disableMfa: async (user_id: number | undefined) => {
      console.info('mfa.tsx_12');
      await disableMfa(user_id, user);
    },
  };
};

export const useIssueMfa = () => {
  console.info('mfa.tsx_13');
  return {
    issueMfa,
  };
};
